import { Component, Input } from '@angular/core'
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone'
import { TranslatePipe } from '@ngx-translate/core'
import { addIcons } from 'ionicons'
import { closeOutline, walletOutline } from 'ionicons/icons'

@Component({
	selector: 'app-casino-wallet-empty-modal',
	templateUrl: './casino-wallet-empty-modal.component.html',
	styleUrls: ['./casino-wallet-empty-modal.component.scss'],
	standalone: true,
	imports: [IonIcon, IonButton, TranslatePipe],
})
export class CasinoWalletEmptyModalComponent {
	@Input() casinoUrl = ''

	constructor(private readonly modalController: ModalController) {
		addIcons({ closeOutline, walletOutline })
	}

	dismiss() {
		void this.modalController.dismiss()
	}

	openTransferWallet() {
		void this.modalController.dismiss({ action: 'transfer-wallet' })
	}

	continueToCasino() {
		if (this.casinoUrl) {
			window.open(this.casinoUrl, '_blank', 'noopener,noreferrer')
		}
		void this.modalController.dismiss()
	}
}
